import { InjectionToken } from '@angular/core';
import { SideMenuAction, Theme } from '@pcplus/infrastructure';

export interface IConfig {
  shortApplicationName: string;
  version: string;
  apiServer: string;
  appFooterText: string;
  appFooterLink: string;
  mainPage: string;
  mainIcon: string;
  mainIconFontSet: string;
  multiTenant: boolean;
  authRedirectPage: string;
  availableThemes: Theme[];
  allowSelfRegistration: boolean;
  availableCurrencies: string[];
  availableLocales: string[];
  disableNotifications: boolean;
  sideMenuActions: SideMenuAction[];
}

export const CONFIG = new InjectionToken<IConfig>(
  'Configuration File Settings'
);
